import useStyles from "../styles";
import logo from "../../../assets/images/logo.svg";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Grid
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import profilemg from "../../../assets/images/profile.png";
import Button from "../../../components/Button";
import { useNavigate } from "react-router-dom";

const FirstReport = ({ extraData = {},
  profile = {},
  extracurricularData = [],
  socialData = [],
  comment = "",
  reportConfig = {},
  subjectResults = [],
  appLogo }) => {
  const classes = useStyles();

  const navigate = useNavigate();

  return (
    <div className="left-container container-border template-left">
      <div className={classes.reportmain}>
        <div className={classes.reportheader}>
          <Grid container spacing={2}>
            <Grid lg={3} md={3} sm={3} xs={12}>
              <div className={classes.imageWrapper}>
                <img
                  src={appLogo && appLogo !== "null" ? appLogo : logo}
                  alt="App Logo"
                  className={appLogo && appLogo !== "null" ? classes.secondlogoContent : classes.logoContent}
                />
              </div>
            </Grid>
            <Grid lg={6} md={6} sm={6} xs={12}>
              <div className={classes.reportheadertext}>
                <h1>{profile?.school_name || "--/--"}</h1>
                <p>{profile?.address || "--/--"}</p>
                <p>{profile?.phone_number || "--/--"}, {profile?.email || "--/--"}</p>
              </div>
            </Grid>
            <Grid lg={3} md={3} sm={3} xs={12}>
              <div>
                <img
                  src={profilemg}
                  alt="Profile"
                  className={classes.profile}
                />
              </div>
            </Grid>
          </Grid>
        </div>
        <div className={classes.termdata}>
          <h1>2024/2025 FIRST TERM STUDENT REPORT</h1>
        </div>
        <Grid container spacing={2}>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>STUDENT NAME</h6>
              <p>{profile?.last_name || "--/--"} {profile?.first_name || "--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>SEX</h6>
              <p>{profile?.sex || "--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>CLASS</h6>
              <p>{profile?.class || "--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>SESSION</h6>
              <p>{profile?.session || "--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>STUDENT TYPE</h6>
              <p>{profile?.session || "--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>ADMISSION NO.</h6>
              <p>{profile?.admission_no || "--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>CLASS POPULATION</h6>
              <p>{profile?.class_population || "--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>DATE ENROLLED</h6>
              <p>{profile?.date_enrolled || "--/--"}</p>
            </div>
          </Grid>
        </Grid>
        <div className={classes.termdata}>
          <h1>SUBJECTS</h1>
        </div>
      </div>
      {/* Subject Results */}
      <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 2, mt: 4, overflowY: "auto" }}>
        <Table sx={{ minWidth: 900 }} aria-label="student performance table">
          <TableHead sx={{ backgroundColor: "#f9fafb" }}>
            <TableRow>
              <TableCell sx={{
                position: "sticky",
                left: 0,
                backgroundColor: "#f9fafb",
                zIndex: 2,
                fontWeight: "500"
              }}
              ><strong>Subject</strong>
              </TableCell>
              {reportConfig.caColumns?.map((ca) => (
                <TableCell key={ca} align="center">{ca}</TableCell>
              ))}

              {reportConfig.exam && <TableCell align="center">Exam</TableCell>}

              <TableCell align="center">Total</TableCell>

              {reportConfig.grade && <TableCell align="center">Grade</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {subjectResults?.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell>{row.subject}</TableCell>

                {reportConfig?.caColumns?.map((caType) => (
                  <TableCell key={caType} align="center">
                    {row[caType] || "--"}
                  </TableCell>
                ))}

                {reportConfig?.exam && (
                  <TableCell align="center">{row.exam || "--"}</TableCell>
                )}

                <TableCell align="center">{row.total || "--"}</TableCell>

                {reportConfig?.grade && (
                  <TableCell align="center">{row.grade || "--"}</TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Grid container spacing={3} sx={{ mt: 1 }}>
        {/* Extracurricular */}
        {extraData?.extras?.length > 0 &&
                                        <Grid item xs={12} md={6}>
                                          <Paper elevation={2} sx={{ borderRadius: 2, p: "8px 14px" }}>
                                            <Box sx={{ position: "relative" }}>
                                              <div className={classes.termdata}>
                                                <h1>EXTRACURRICULARS</h1>
                                              </div>
                                              {/* <Box sx={{ bgcolor: "white", padding: "0.5rem", borderRadius: "6px", position: "absolute", top: -28, right: -10 }}>
                                                <IconButton sx={{ bgcolor: "white", boxShadow: 2 }} size="small">
                                                  <EditIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton sx={{ bgcolor: "white", boxShadow: 2, ml: 1 }} size="small">
                                                  <DeleteIcon fontSize="small" color="error" />
                                                </IconButton>
                                              </Box> */}
                                            </Box>

                                            <Table sx={{ mt: 2 }}>
                                              <TableHead sx={{ backgroundColor: "#f9fafb" }}>
                                                <TableRow>
                                                  <TableCell>ACTIVITY</TableCell>
                                                  <TableCell align="right">GRADE</TableCell>
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                {extracurricularData?.map((row, idx) => (
                                                  <TableRow key={idx}>
                                                    <TableCell>{row.activity}</TableCell>
                                                    <TableCell align="right">{row.grade}</TableCell>
                                                  </TableRow>
                                                ))}
                                              </TableBody>
                                            </Table>
                                          </Paper>
                                        </Grid>
        }

        {/* Social */}
        {extraData?.extras?.length > 0 &&
                      <Grid item xs={12} md={6}>
                        <Paper elevation={2} sx={{ borderRadius: 2, p: "8px 14px" }}>
                          <Box sx={{ position: "relative" }}>
                            <div className={classes.termdata}>
                              <h1>SOCIAL</h1>
                            </div>
                            {/* <Box sx={{ bgcolor: "white", padding: "0.5rem", borderRadius: "6px", position: "absolute", top: -28, right: -10 }}>
                              <IconButton sx={{ bgcolor: "white", boxShadow: 2 }} size="small">
                                <EditIcon fontSize="small" />
                              </IconButton>
                              <IconButton sx={{ bgcolor: "white", boxShadow: 2, ml: 1 }} size="small">
                                <DeleteIcon fontSize="small" color="error" />
                              </IconButton>
                            </Box> */}
                          </Box>

                          <Table sx={{ mt: 2 }}>
                            <TableHead sx={{ backgroundColor: "#f9fafb" }}>
                              <TableRow>
                                <TableCell>ACTIVITY</TableCell>
                                <TableCell align="right">SCORE</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {socialData?.map((row, idx) => (
                                <TableRow key={idx}>
                                  <TableCell>{row?.activity}</TableCell>
                                  <TableCell align="right">{row?.score}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </Paper>
                      </Grid>
        }
        {/* Teacher's Comment */}
        {extraData?.extras?.length > 0 &&
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <Paper elevation={2} sx={{ borderRadius: 2, p: "8px 14px" }}>
                          <Box sx={{ position: "relative" }}>
                            <div className={classes.termdata}>
                              <h1>TEACHER’S COMMENT</h1>
                            </div>
                            <Box sx={{ bgcolor: "white", padding: "0.5rem", borderRadius: "6px", position: "absolute", top: -28, right: -10 }}>
                              <IconButton sx={{ bgcolor: "white", boxShadow: 2 }} size="small">
                                <EditIcon fontSize="small" />
                              </IconButton>
                              <IconButton sx={{ bgcolor: "white", boxShadow: 2, ml: 1 }} size="small">
                                <DeleteIcon fontSize="small" color="error" />
                              </IconButton>
                            </Box>
                          </Box>

                          <Box
                            sx={{
                              mt: 2,
                              p: 2,
                              borderRadius: 2,
                              backgroundColor: "#f9fafb",
                              fontSize: "0.95rem",
                              textAlign: "left",
                              color: "#333"
                            }}
                          >
                            {comment}
                          </Box>
                        </Paper>
                      </Grid>
        }
      </Grid>
      <div className="flex justify-content-center">
        <Button
          variant="primary"
          buttonSize="fluid"
          color="btndefault"
          buttonName="Done"
          onClick={() => navigate("/report/custom")}
        />
      </div>
    </div>
  );
};

export default FirstReport;
